import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Label, Input, PrimaryBtn } from "@/components/admin/ui";
import { UserCog } from "lucide-react";

export default function ProfilePanel() {
  const [nickname, setNickname] = useState("");
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/auth/me").then((r) => {
      setNickname(r.data.nickname || "");
      setName(r.data.name || "");
      setLoaded(true);
    }).catch(() => setLoaded(true));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/auth/profile", { nickname: nickname.trim(), name: name.trim() });
      toast.success("Profilo aggiornato");
    } catch {
      toast.error("Errore nel salvataggio");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-lg" data-testid="profile-panel">
      <h2 className="flex items-center gap-2 font-heading text-xl font-bold uppercase text-zinc-100 mb-2">
        <UserCog className="h-5 w-5 text-yellow-400" /> Il mio profilo
      </h2>
      <p className="text-sm text-zinc-500 mb-6">
        Imposta un nickname da pilota. Comparirai con questo nome tra i piloti e negli iscritti quando ti iscrivi a un campionato o a un Gran Premio.
      </p>
      <div className="space-y-4">
        <div>
          <Label>Nome</Label>
          <Input value={name} onChange={(e) => setName(e.target.value)} className="mt-2"
            placeholder="Il tuo nome" data-testid="profile-name" disabled={!loaded} />
        </div>
        <div>
          <Label>Nickname pilota</Label>
          <Input value={nickname} onChange={(e) => setNickname(e.target.value)} className="mt-2"
            placeholder="es. Il Tuono" data-testid="profile-nickname" disabled={!loaded} />
        </div>
        <PrimaryBtn onClick={save} disabled={saving || !loaded} data-testid="save-profile-btn">
          {saving ? "Salvataggio…" : "Salva profilo"}
        </PrimaryBtn>
      </div>
    </div>
  );
}
